module.exports = __webpack_public_path__ + "img/66.85f1ed3b.png";